import { ImageCreator } from './ImageCreator';
import type { IRegister } from './types';
import type { ImageType } from './ImageCreator';

type FormResourceProps = {
  form: ImageType;
  register: IRegister<ImageType>;
};
export const FormResource = ({ form, register }: FormResourceProps) => {
  return <ImageCreator form={form} register={register} />;
};
